import { Container, Grid, IconButton, useTheme } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { HELP_QUESTIONS_CRYPTO, HELP_QUESTIONS_FIAT } from "./constants";
import {
  Link,
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useEffect, useState } from "react";

import BackButton from "components/BackButton";
import CoinTypeTab from "components/CoinTypeTab";
import DepositOrWithdrawTab from "pages/Deposit/DepositDesktop/Components/DepositOrWithdrawTab";
import { GetWithdrawInitial } from "store/api/withdraw";
import HelpBox from "components/HelpBox";
import { History } from "assets/Icon";
import WithdrawForm from "./WithdrawForm";
import WithdrawFormSkeleton from "components/Skeletons/WithdrawForm.Skeleton";
import WithdrawOrDepositHistory from "pages/History/WithdrawOrDepositHistory";
import http from "config/http";
import useIsMobileView from "hooks/useIsMobileView";
import useNotify from "hooks/useNotify";

function Withdraw() {
  const isMobileView = useIsMobileView();
  const notify = useNotify();
  const navigate = useNavigate();
  const theme = useTheme();

  const [searchParams] = useSearchParams();
  const isDigital =
    searchParams.get("isDigital")?.toLocaleLowerCase() !== "false";

  const allSearchParams = Object.fromEntries([...searchParams]);

  const params = useParams();
  const coinId = +params?.id;

  const [withdrawInitial, setWithdrawInitial] = useState();

  const methods = useForm({
    defaultValues: {
      coinId: coinId || 1,
      typeId: 1,
      networkId: 1,
      amount: null,
      address: "",
      tagOrMemo: "",
      proposal: "",
      isDigital: isDigital,
    },
  });

  const { reset } = methods;

  const getWithdrawInitial = async () => {
    try {
      const { data } = await http.get(GetWithdrawInitial);

      setWithdrawInitial(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  useEffect(() => {
    getWithdrawInitial();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    reset((formValues) => ({
      ...formValues,
      address: "",
      amount: "",
      tagOrMemo: "",
      proposal: "",
    }));
  }, [coinId, reset]);

  return (
    <>
      <Container maxWidth="md">
        <FormProvider {...methods}>
          <form>
            <Grid container spacing={1}>
              {!isMobileView && <DepositOrWithdrawTab />}

              {isMobileView && (
                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="space-between"
                  mt={2}
                >
                  <BackButton text="Withdraw" to="/wallet/spot" />
                  <IconButton
                    aria-label="history"
                    size="small"
                    component={Link}
                    to={"/history/spot?sideId=2"}
                  >
                    <History color={theme.palette.secondary.main} />
                  </IconButton>
                </Grid>
              )}

              <Grid item xs={12}>
                <CoinTypeTab
                  coinList={withdrawInitial}
                  onChange={(data) =>
                    navigate({
                      pathname: `/withdraw/${data?.id}`,
                      search: `?${createSearchParams({
                        ...allSearchParams,
                        isDigital: data?.isDigital,
                      })}`,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={7}>
                {withdrawInitial ? (
                  <WithdrawForm
                    getWithdrawInitial={getWithdrawInitial}
                    withdrawInitial={withdrawInitial}
                  />
                ) : (
                  <WithdrawFormSkeleton />
                )}
              </Grid>

              {!isMobileView && (
                <Grid item xs={12} md={5}>
                  <HelpBox
                    questions={
                      isDigital ? HELP_QUESTIONS_CRYPTO : HELP_QUESTIONS_FIAT
                    }
                    title="راهنما و سوالات متداول"
                  />
                </Grid>
              )}
            </Grid>
          </form>
        </FormProvider>
      </Container>

      <WithdrawOrDepositHistory show24h={isMobileView} />
    </>
  );
}

export default Withdraw;
